import styled from 'styled-components';

export const FinancialHeaderWrapper = styled.div`
  background-color: #fff;
  margin: 0 -1.2rem 8px;
  width: calc(100% + 2.4rem);
  box-sizing: border-box;
  border-bottom: 1px solid #ebebeb;
  position: relative;
  z-index: 2;
  font-family: 'Inter', sans-serif;
`;

export const HeaderTopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px 16px;
  padding: 0.45rem 1.2rem;
`;

export const FinancialLeftSide = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
  flex: 1;
  min-width: 0;
`;

export const FinancialRightSide = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  position: relative;
  z-index: 5;
`;

export const ButtonOutline = styled.button`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  height: 2rem;
  padding: 0 0.9rem;
  background-color: transparent;
  border: 1px solid #0090d3;
  border-radius: 2rem;
  cursor: pointer;
  font-size: 0.72rem;
  font-weight: bold;
  color: #0090d3;
  white-space: nowrap;

  &:hover {
    background-color: #e6f4fb;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const FilterTriggerButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 2rem;
  padding: 0 0.9rem;
  background-color: #fff;
  border: 1px solid #0090d3;
  border-radius: 2rem;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-size: 0.72rem;
  font-weight: bold;
  color: #0090d3;
  white-space: nowrap;
  box-sizing: border-box;

  svg {
    color: #0090d3;
    flex-shrink: 0;
    width: 14px;
    height: 14px;
  }
`;

export const Content = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  margin-top: 15px;
  font-family: 'Inter', sans-serif;
  box-sizing: border-box;
`;

export const ListContent = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  margin-top: 15px;
  font-family: 'Inter', sans-serif;
  box-sizing: border-box;
`;

export const FormScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
  box-sizing: border-box;

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`;

export const FormMainContainer = styled.div`
  background-color: #f4f4f4;
  padding-bottom: 16px;
`;
